import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  pressableBackground: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
  },

  container: {
    borderRadius: 22,
    backgroundColor: '#EBEBEB',
    width: 500,
    padding: 20,
  },

  title: {
    fontSize: 24,
    fontFamily: 'Raleway_700Bold',
    color: '#1F647A',
    alignSelf: 'flex-start',
    marginBottom: 30,
  },

  button: {
    height: 50,
    width: 340,
    backgroundColor: '#6BC041',
    borderWidth: 2,
    borderColor: '#559933',
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
    alignSelf: 'center',
  },

  textButton: {
    fontFamily: 'Montserrat_700Bold',
    fontSize: 20,
    color: 'white',
  },

  image1: {
    width: 335.8,
    height: 171.5,
    alignSelf: 'center',
    resizeMode: 'contain',
    marginBottom: 30,
  },
  image2: {
    width: 280,
    height: 300,
    resizeMode: 'contain',
    alignSelf: 'center',
    marginBottom: 30,
  },

  image3: {
    width: 301,
    height: 270,
    resizeMode: 'contain',
    alignSelf: 'center',
    marginBottom: 30,
  },
  image4: {
    width: 285,
    height: 317,
    resizeMode: 'contain',
    alignSelf: 'center',
    marginBottom: 30,
  },

  textDescription: {
    fontSize: 18,
    fontFamily: 'Raleway_400Regular',
  },
  textDescription2: {
    fontSize: 18,
    marginTop: 15,
    fontFamily: 'Raleway_400Regular',
    color: '#C14D4D',
  },
});
